
export const frontendUrl = 'https://restau-pos.webyms.com/'
// export const frontendUrl = 'http://192.168.147.46:8080/'
export const backendUrl = 'https://be.restau-pos.webyms.com/'

export const currency = "DH";
